import { Auth } from 'aws-amplify';

/**
 * Obtains the Cognito access token used to authorize API calls. Reads the current Amplify session and extracts its JWT, and on failure logs the error and retries the session lookup once before giving up with a null token.
 *
 * @returns A promise resolving to the JWT access token, or null when both attempts fail.
 */
const getAccessToken = async () => {
  let accessToken = null;
  try {
    const session = await Auth.currentSession();
    accessToken = session.getAccessToken().getJwtToken();
  } catch (error) {
    console.error('Failed to get access token: ', error);

    // Retry to get token if the first attempt fails
    try {
      const retrySession = await Auth.currentSession();
      accessToken = retrySession.getAccessToken().getJwtToken();
    } catch (retryError) {
      console.error('Failed to get access token on retry: ', retryError);
    }
  }

  return accessToken;
};

export default getAccessToken;
